import { z } from "zod";

export const createProgramaSchema = z.object({
  idClienteFinal: z.number().int().positive(),
  nombre: z.string().min(1),
  tono: z.string().min(1),
  rol: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message: "El rol no puede exceder 65,535 caracteres",
    }),
  restricciones: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message: "Las restricciones no pueden exceder 65,535 caracteres",
    }),
  formato: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message: "El formato no puede exceder 65,535 caracteres",
    }),
  // cupoMaximo: z.number().int().min(0), // permite 0
  limiteIntentos: z.number().int().min(1).default(3).optional(),
  fechaInicio: z.coerce.date(),
  fechaFin: z.coerce.date(),
  contexto_coach: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message: "El contexto del coach no puede exceder 65,535 caracteres",
    }),
  rol_coach: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message: "El rol del coach no puede exceder 65,535 caracteres",
    }),
  tarea_coach: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message: "La tarea del coach no puede exceder 65,535 caracteres",
    }),
  restricciones_criterios_coach: z
    .string()
    .optional()
    .nullable()
    .refine((val) => !val || val.length <= 65535, {
      message:
        "Las restricciones del coach no pueden exceder 65,535 caracteres",
    }),
});

export type CreateProgramaInput = z.infer<typeof createProgramaSchema>;
